/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Buyer_LocInputs */

const en_delivery_buyer_loc = /** @type {(inputs: Delivery_Buyer_LocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyer Location`)
};

const es_delivery_buyer_loc = /** @type {(inputs: Delivery_Buyer_LocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación del Comprador`)
};

const fr_delivery_buyer_loc = /** @type {(inputs: Delivery_Buyer_LocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplacement de l'acheteur`)
};

const de_delivery_buyer_loc = /** @type {(inputs: Delivery_Buyer_LocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort des Käufers`)
};

const id_delivery_buyer_loc = /** @type {(inputs: Delivery_Buyer_LocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokasi Pembeli`)
};

/** @type {(inputs: Delivery_Buyer_LocInputs) => LocalizedString} */
const ja_delivery_buyer_loc = en_delivery_buyer_loc;

/** @type {(inputs: Delivery_Buyer_LocInputs) => LocalizedString} */
const zh_delivery_buyer_loc = en_delivery_buyer_loc;

/** @type {(inputs: Delivery_Buyer_LocInputs) => LocalizedString} */
const ar_delivery_buyer_loc = en_delivery_buyer_loc;

/** @type {(inputs: Delivery_Buyer_LocInputs) => LocalizedString} */
const it_delivery_buyer_loc = en_delivery_buyer_loc;

/** @type {(inputs: Delivery_Buyer_LocInputs) => LocalizedString} */
const ru_delivery_buyer_loc = en_delivery_buyer_loc;

/** @type {(inputs: Delivery_Buyer_LocInputs) => LocalizedString} */
const pt_delivery_buyer_loc = en_delivery_buyer_loc;

/** @type {(inputs: Delivery_Buyer_LocInputs) => LocalizedString} */
const ko_delivery_buyer_loc = en_delivery_buyer_loc;

/**
* | output |
* | --- |
* | "Buyer Location" |
*
* @param {Delivery_Buyer_LocInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_buyer_loc = /** @type {((inputs?: Delivery_Buyer_LocInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Buyer_LocInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_buyer_loc(inputs)
	if (locale === "es") return es_delivery_buyer_loc(inputs)
	if (locale === "fr") return fr_delivery_buyer_loc(inputs)
	if (locale === "de") return de_delivery_buyer_loc(inputs)
	if (locale === "ja") return ja_delivery_buyer_loc(inputs)
	if (locale === "zh") return zh_delivery_buyer_loc(inputs)
	if (locale === "ar") return ar_delivery_buyer_loc(inputs)
	if (locale === "id") return id_delivery_buyer_loc(inputs)
	if (locale === "it") return it_delivery_buyer_loc(inputs)
	if (locale === "ru") return ru_delivery_buyer_loc(inputs)
	if (locale === "pt") return pt_delivery_buyer_loc(inputs)
	return ko_delivery_buyer_loc(inputs)
});